export const validateURL = (axiosInstance, params) => {
    const url = `api/v1/oauth/validateUrl${params}`;
    return axiosInstance.get(url);
};

export const scopeDetails = (axiosInstance, params) => {
    let url = `api/v1/oauth/getScopeDetails?client_id=${params.clientId}&scopes=${params.scope}`;
    if (params.thirdPartyUserId) {
        url += `&third_party_user_id=${params.thirdPartyUserId}`;
    }
    return axiosInstance.get(url);
};

export const authorize = (axiosInstance, clientId, scopeList, thirdPartyUserId, approvalPrompt) => {
    const url = 'api/v1/oauth/authorize';
    const data = {
        client_id: clientId,
        approval_prompt: approvalPrompt,
        scopes: scopeList.map(scope => scope.name),
    };
    if (thirdPartyUserId) {
        data.third_party_user_id = thirdPartyUserId;
    }
    return axiosInstance.post(url, data);
};

export const getTennisAustraliaUserProfile = (axiosInstance, state) => {
    const url = `/v1/oauth/ta/confirm-profile?state=${state}`;
    return axiosInstance.get(url);
};

export const confirmTennisAustraliaUser = (axiosInstance, state, payload) => {
    const url = `/v1/oauth/ta/confirm-profile?state=${state}`;
    return axiosInstance.put(url, payload);
};

export const getAppleUserProfile = (axiosInstance, state) => {
    const url = `/v3/oauth/apple/confirm-profile?state=${state}`;
    return axiosInstance.get(url);
};

export const confirmAppleUser = (axiosInstance, state, payload) => {
    const url = `/v3/oauth/apple/confirm-profile?state=${state}`;
    return axiosInstance.put(url, payload);
};

export const getFacebookUserProfile = (axiosInstance, state) => {
    const url = `/v3/oauth/facebook/confirm-profile?state=${state}`;
    return axiosInstance.get(url);
};

export const confirmFacebookUser = (axiosInstance, state, payload) => {
    const url = `/v3/oauth/facebook/confirm-profile?state=${state}`;
    return axiosInstance.put(url, payload);
};
